import process from "/home/runner/work/vets-website/vets-website/node_modules/process/browser.js";
export { process };
